import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "club-container"
  }, [_c("vue-editor", {
    staticStyle: {
      display: "none"
    }
  }), _c("van-pull-refresh", {
    attrs: {
      "loading-text": _vm.$t("LoadingTxt"),
      "loosing-text": _vm.$t("LoosingTxt"),
      "pulling-text": _vm.$t("pullingTxt")
    },
    on: {
      refresh: _vm.onRefresh
    },
    model: {
      value: _vm.isLoading,
      callback: function callback($$v) {
        _vm.isLoading = $$v;
      },
      expression: "isLoading"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowWrap,
      expression: "isShowWrap"
    }],
    staticClass: "wrap"
  }), _c("div", {
    staticClass: "swipe-con"
  }, [_c("van-swipe", {
    staticClass: "my-swipe",
    attrs: {
      autoplay: 3000,
      "indicator-color": "white"
    }
  }, _vm._l(_vm.banner, function (item, index) {
    return _c("van-swipe-item", {
      key: index,
      on: {
        click: function click($event) {
          return _vm.toUrl(item.url);
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.bannerUrl,
        alt: ""
      }
    }), _c("div", {
      staticClass: "swipe-text"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]);
  }), 1)], 1), _c("div", {
    staticClass: "entry-quick"
  }, [_c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("quickAccess")))]), _c("div", {
    staticClass: "entry-con"
  }, [_c("div", {
    staticClass: "item",
    on: {
      click: _vm.toManual
    }
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/images/qick_img01.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("Brochure")))])]), _c("div", {
    staticClass: "item",
    on: {
      click: _vm.toTestDrive
    }
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/images/qick_img02.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("TestDrive")))])]), _c("div", {
    staticClass: "item",
    on: {
      click: _vm.answerQuestion
    }
  }, [_c("img", {
    attrs: {
      src: require("../../../assets/images/qick_img03.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("Questionnaire")))])])])]), _c("div", {
    staticClass: "dynamic"
  }, [_c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("Post")))]), _c("div", {
    staticClass: "select-con",
    on: {
      click: _vm.showSelectPop
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.type)))]), _c("img", {
    attrs: {
      src: require("../../../assets/images/ic_my_club_unfold.png"),
      alt: ""
    }
  })]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowSelectPop,
      expression: "isShowSelectPop"
    }],
    staticClass: "pop"
  }, _vm._l(_vm.typeArr, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toSelect(item);
        }
      }
    }, [_c("span", {
      class: {
        active: item.selected
      }
    }, [_vm._v(_vm._s(_vm.$t(item.txt)))])]);
  }), 0)]), _vm.topData.length > 0 && _vm.type === "Latest" ? _c("div", {
    staticClass: "club"
  }, _vm._l(_vm.topData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "club-item",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.likeReward.postCount);
        }
      }
    }, [_c("div", {
      staticClass: "user"
    }, [_c("div", {
      staticClass: "user-info",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toMe(item.user.userId, item.user.follow_status);
        }
      }
    }, [item.user.avatar ? _c("img", {
      staticClass: "img",
      attrs: {
        src: item.user.avatar,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "txt"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.user.nickname))]), _c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.createdAt))])])]), _vm.userId != item.user.userId ? _c("div", [item.user.follow_status == 2 ? _c("div", {
      staticClass: "follow",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toFollow(item.user.userId, item, "top");
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("Follow")) + " ")]) : _vm._e(), item.user.follow_status == 1 ? _c("div", {
      staticClass: "unFollow",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toUnfollow(item.user.userId, item, "top");
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("friend")) + " ")]) : _vm._e(), item.user.follow_status == 0 ? _c("div", {
      staticClass: "unFollow",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toUnfollow(item.user.userId, item, "top");
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("Unfollow")) + " ")]) : _vm._e()]) : _vm._e()]), _c("div", [_c("div", {
      staticClass: "explain ql-editor"
    }, [item.isStick && _vm.type === "Latest" ? _c("img", {
      staticClass: "stick",
      attrs: {
        src: require("../../../assets/images/TOP.png"),
        alt: ""
      }
    }) : _vm._e(), item.content.title ? _c("span", {
      domProps: {
        innerHTML: _vm._s(item.content.title)
      }
    }) : _vm._e(), _c("span", {
      staticStyle: {
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "3",
        overflow: "hidden"
      },
      domProps: {
        innerHTML: _vm._s(item.content.text)
      }
    }), item.content.text.length > 100 ? _c("span", {
      staticStyle: {
        color: "darkgrey"
      }
    }, [_vm._v(_vm._s(_vm.$t("seeMore")) + " >>")]) : _vm._e()]), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 1 ? _c("div", {
      staticClass: "img-con"
    }, _vm._l(item["content"]["indexes"]["101"]["body"], function (itm) {
      return _c("van-image", {
        key: itm.thumbUrl,
        attrs: {
          fit: "cover",
          src: itm.thumbUrl
        }
      });
    }), 1) : _vm._e(), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("div", {
      staticClass: "video-con"
    }, _vm._l(item["content"]["indexes"]["101"]["body"], function (itm) {
      return _c("video", {
        key: itm.thumbUrl,
        attrs: {
          controls: "",
          controlslist: "nodownload noremoteplayback",
          poster: itm.poster,
          "x5-playsinline": "",
          playsinline: "true",
          "webkit-playsinline": ""
        }
      }, [_c("source", {
        attrs: {
          src: itm.thumbUrl,
          type: "video/mp4"
        }
      })]);
    }), 0) : _vm._e()]), item.topic.length > 0 ? _c("div", {
      staticClass: "tags"
    }, _vm._l(item.topic, function (item1) {
      return _c("div", {
        key: item1.id,
        staticClass: "tags-item",
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return _vm.toTopic(item1.id);
          }
        }
      }, [_c("img", {
        staticClass: "sign",
        attrs: {
          src: require("../../../assets/images/Topic-list-icon-blue.png"),
          alt: ""
        }
      }), _c("span", {
        staticClass: "clubs"
      }, [_vm._v(_vm._s(item1.content))])]);
    }), 0) : _vm._e(), _c("div", {
      staticClass: "user-operate",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.likeReward.postCount);
        }
      }
    }, [_c("div", {
      staticClass: "item-con"
    }, [_c("div", {
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/ic_other_more_comment.png"),
        alt: ""
      }
    }), item.likeReward.postCount ? _c("span", [_vm._v(_vm._s(item.likeReward.postCount))]) : _c("span")]), _c("div", {
      staticClass: "item",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.thumbsUp(item);
        }
      }
    }, [!item.isLike ? _c("img", {
      attrs: {
        src: require("../../../assets/images/ic_other_more_like.png"),
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("../../../assets/images/Like1.png"),
        alt: ""
      }
    }), item.likeReward.likePayCount ? _c("span", [_vm._v(_vm._s(item.likeReward.likePayCount))]) : _c("span")]), _c("div", {
      staticClass: "item",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toCollect(item);
        }
      }
    }, [!item.isFavorite ? _c("img", {
      attrs: {
        src: require("../../../assets/images/ic_other_more_collect.png"),
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("../../../assets/images/Collection1.png"),
        alt: ""
      }
    }), item.likeReward.favoriteCount ? _c("span", [_vm._v(_vm._s(item.likeReward.favoriteCount))]) : _c("span")])])])]);
  }), 0) : _vm._e(), _vm.clubData.length > 0 ? _c("div", {
    staticClass: "club"
  }, [_c("van-list", {
    attrs: {
      "loading-text": _vm.$t("LoadingTxt"),
      finished: _vm.finished,
      "finished-text": _vm.$t("NoMoreContents")
    },
    on: {
      load: _vm.onLoad
    },
    model: {
      value: _vm.loading,
      callback: function callback($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, _vm._l(_vm.clubData, function (item, index) {
    return _c("van-cell", {
      key: index,
      staticClass: "club-item"
    }, [_c("div", {
      staticClass: "user"
    }, [_c("div", {
      staticClass: "user-info",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toMe(item.user.userId);
        }
      }
    }, [item.user.avatar ? _c("img", {
      staticClass: "img",
      attrs: {
        src: item.user.avatar,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "txt"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.user.nickname))]), _c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.createdAt))])])]), _vm.userId != item.user.userId ? _c("div", [item.user.follow_status == 2 ? _c("div", {
      staticClass: "follow",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toFollow(item.user.userId, item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("Follow")) + " ")]) : _vm._e(), item.user.follow_status == 1 ? _c("div", {
      staticClass: "unFollow",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toUnfollow(item.user.userId, item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("friend")) + " ")]) : _vm._e(), item.user.follow_status == 0 ? _c("div", {
      staticClass: "unFollow",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toUnfollow(item.user.userId, item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("Unfollow")) + " ")]) : _vm._e()]) : _vm._e()]), _c("div", [item.content.text ? _c("div", {
      staticClass: "explain ql-editor",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.likeReward.postCount);
        }
      }
    }, [item.isStick && _vm.type === "Latest" ? _c("img", {
      staticClass: "stick",
      attrs: {
        src: require("../../../assets/images/TOP.png"),
        alt: ""
      }
    }) : _vm._e(), item.content.title ? _c("span", {
      domProps: {
        innerHTML: _vm._s(item.content.title)
      }
    }) : _vm._e(), _c("span", {
      staticStyle: {
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "3",
        overflow: "hidden"
      },
      domProps: {
        innerHTML: _vm._s(item.content.text)
      }
    }), item.content.text.length > 100 ? _c("span", {
      staticStyle: {
        color: "darkgrey"
      }
    }, [_vm._v(_vm._s(_vm.$t("seeMore")) + " >>")]) : _vm._e()]) : _vm._e(), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && (item["content"]["indexes"]["101"]["body"][0].type == 1 || item["content"]["indexes"]["101"]["body"][0].type == 0) ? _c("div", {
      staticClass: "img-con",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.likeReward.postCount);
        }
      }
    }, _vm._l(item["content"]["indexes"]["101"]["body"], function (itm) {
      return _c("van-image", {
        key: itm.thumbUrl,
        attrs: {
          fit: "cover",
          src: itm.thumbUrl
        }
      });
    }), 1) : _vm._e(), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("div", {
      staticClass: "video-con"
    }, _vm._l(item["content"]["indexes"]["101"]["body"], function (itm) {
      return _c("video", {
        key: itm.url,
        attrs: {
          controls: "",
          controlslist: "nodownload noremoteplayback",
          poster: itm.poster,
          "x5-playsinline": "",
          playsinline: "true",
          "webkit-playsinline": ""
        }
      }, [_c("source", {
        attrs: {
          src: itm.url
        }
      })]);
    }), 0) : _vm._e()]), item.topic.length > 0 ? _c("div", {
      staticClass: "tags"
    }, _vm._l(item.topic, function (item1) {
      return _c("div", {
        key: item1.id,
        staticClass: "tags-item",
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return _vm.toTopic(item1.id);
          }
        }
      }, [_c("img", {
        staticClass: "sign",
        attrs: {
          src: require("../../../assets/images/Topic-list-icon-blue.png"),
          alt: ""
        }
      }), _c("span", {
        staticClass: "clubs"
      }, [_vm._v(_vm._s(item1.content))])]);
    }), 0) : _vm._e(), _c("div", {
      staticClass: "user-operate",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.likeReward.postCount);
        }
      }
    }, [_c("div", {
      staticClass: "item-con"
    }, [_c("div", {
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/ic_other_more_comment.png"),
        alt: ""
      }
    }), item.likeReward.postCount ? _c("span", [_vm._v(_vm._s(item.likeReward.postCount))]) : _c("span")]), _c("div", {
      staticClass: "item",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.thumbsUp(item);
        }
      }
    }, [!item.isLike ? _c("img", {
      attrs: {
        src: require("../../../assets/images/ic_other_more_like.png"),
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("../../../assets/images/Like1.png"),
        alt: ""
      }
    }), item.likeReward.likePayCount ? _c("span", [_vm._v(_vm._s(item.likeReward.likePayCount))]) : _c("span")]), _c("div", {
      staticClass: "item",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toCollect(item);
        }
      }
    }, [!item.isFavorite ? _c("img", {
      attrs: {
        src: require("../../../assets/images/ic_other_more_collect.png"),
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("../../../assets/images/Collection1.png"),
        alt: ""
      }
    }), item.likeReward.favoriteCount ? _c("span", [_vm._v(_vm._s(item.likeReward.favoriteCount))]) : _c("span")])])])]);
  }), 1)], 1) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };